import React from "react";
import { motion } from "framer-motion";

const projects = [
  {
    category: "Автоматизация",
    title: "Предиктивная диагностика инфраструктуры",
    desc: "Мониторинг рабочих станций, ВМ и контейнеров в реальном времени. Внедрение позволило снизить время простоя на 15%.",
    image: "/assets/diagnostic.png",
    tag: "IoT / Big Data",
  },
  {
    category: "Инфобезопасность",
    title: "Обеспечение безопасности ИТ-объектов",
    desc: "Обеспечение безопасности узлов информационной инфраструктуры. Контроль параметров серверов, рабочих станций, ВМ и контейнеров.  ",
    image: "/assets/cybersecurity.png",
    tag: "Security / Audit",
  },
  {
    category: "Разработка ПО",
    title: "Системы управления работой команды",
    desc: "Единая платформа управления ремонтными работами. Автоматизация 90% бумажного документооборота и прозрачный контроль работ команды.",
    image: "/assets/mobileapp.png",
    tag: "Enterprise / Web",
  },
];

export default function Projects() {
  return (
    <section id="projects" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-4 mb-16">
          <h2 className="text-4xl font-black text-slate-900 uppercase italic tracking-tighter">
            КЕЙСЫ
          </h2>
          <div className="h-px flex-1 bg-slate-100"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {projects.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="group relative h-[500px] rounded-[2.5rem] overflow-hidden bg-slate-900 border border-slate-200"
            >
              {/* Изображение на фоне */}
              <img
                src={p.image}
                alt={p.title}
                className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-40 group-hover:scale-110 transition-all duration-700"
              />

              {/* Градиентное затемнение для читаемости текста */}
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/20 to-transparent"></div>

              {/* Контент поверх фото */}
              <div className="absolute inset-0 p-8 flex flex-col justify-end">
                <div className="space-y-4">
                  {/* ФИКСИРОВАННЫЙ КОНТЕЙНЕР ДЛЯ ТЕГА (решает проблему выравнивания) */}
                  <div className="h-8 flex items-center">
                    <span className="inline-block px-3 py-1 rounded-lg bg-blue-600 text-white text-[10px] font-black uppercase tracking-widest whitespace-nowrap">
                      {p.category}
                    </span>
                  </div>

                  {/* КОНТЕЙНЕР ДЛЯ ЗАГОЛОВКА С ФИКСИРОВАННОЙ ВЫСОТОЙ */}
                  <div className="h-20 flex items-start">
                    <h3 className="text-2xl font-black text-white leading-tight">
                      {p.title}
                    </h3>
                  </div>

                  <p className="text-slate-300 text-sm leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-500 line-clamp-3">
                    {p.desc}
                  </p>

                  <div className="flex items-center justify-between pt-4 border-t border-white/10">
                    <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest">
                      {p.tag}
                    </span>
                    <button className="text-white hover:text-blue-400 transition-colors">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M5 12h14M12 5l7 7-7 7" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
